<template>
  <div>
    <div class="container" id="mobileToggles">
      <em>Toggle Offices types: </em>
      
      
      <span
        v-on:click="toggleDLswitch"
        v-bind:class="[this.rootStore.toggleDL ? 'badge badge-success' : 'badge']">
        License
      </span>

 

       <!-- Show Saturday checkbox if any are available --> 
        <span v-if="this.rootStore.officeDLSaturday.length > 0">
          
          <input 
            @change="toggleSaturdayDLswitch"
            :disabled="this.rootStore.toggleDL === false"
            type="checkbox" id="satudayMobileDLcheckbox" v-model="this.rootStore.toggleDLSaturday" />
          
          <label for="satudayMobileDLcheckbox">Saturday license hours</label>

        </span>

      <span class="closedCheckboxMobile">
        <input @change="toggleCLOSEDswitch" type="checkbox" id="settingsClosedcheckboxMobile"
          v-model="this.rootStore.toggleClosed" /> 
        <label for="settingsClosedcheckboxMobile">Closed temporarily</label>
      </span>
        <hr v-if="this.rootStore.officeDLSaturday.length > 0" />

      <span
        v-on:click="toggleLPAswitch"
        v-bind:class="[this.rootStore.toggleLPA ? 'badge badge-success' : 'badge']"
      >
        Plate / Vehicle
      </span>
      <!-- <span
        v-on:click="toggleMOswitch"
        v-bind:class="[getToggleMO ? 'badge badge-success' : 'badge']"
      >
        Mobile
      </span> -->
      <span
        v-on:click="toggleIRPswitch"
        v-bind:class="[this.rootStore.toggleIRP ? 'badge badge-success' : 'badge']"
        >Trucking (IRP)
      </span>
    </div>
 
  </div>
</template>


<script>
import { useRootStore } from "../store";

export default {
  data() {
    return {
      rootStore: useRootStore()
    }
  },
  methods: {
    zoomBigMapToOffice(plat, plong) {
      var _zoomCoords = {};

      _zoomCoords.Lat = plat;
      _zoomCoords.Long = plong;

      document
        .getElementById("dmvLocsDashboard")
        .scrollIntoView({ behavior: "smooth", block: "center" });

      // clear any primary selected result
      this.rootStore.SET_PRIMARY_CARD("");

      this.rootStore.SET_ZOOMED_LOCATION(_zoomCoords);
    },

    toggleCLOSEDswitch: function (event) {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.TOGGLE_SWITCH_CLOSED(event.target.checked);
    },

    toggleSaturdayDLswitch: function () {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.SET_PRIMARY_CARD([]);
      this.rootStore.TOGGLE_SWITCH_LPA(false);      
      this.rootStore.TOGGLE_SWITCH_IRP(false);
      this.rootStore.TOGGLE_SWITCH_LT(false);

      this.rootStore.TOGGLE_SWITCH_DL(true);


      if (this.rootStore.toggleDLSaturday === false) {
        return this.rootStore.TOGGLE_SWITCH_DL_SATURDAY(true);
      } else {
        return this.rootStore.TOGGLE_SWITCH_DL_SATURDAY(false);
      }
    },

    toggleDLswitch: function () {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.SET_PRIMARY_CARD([]);
      if (this.getToggleDL === false) {
        this.rootStore.TOGGLE_SWITCH_DL_SATURDAY(false);
        this.rootStore.TOGGLE_SWITCH_DL(true);
      } else {
        this.rootStore.TOGGLE_SWITCH_DL(false);
      }
    },
    toggleLPAswitch: function () {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.SET_PRIMARY_CARD([]);

      if (this.rootStore.toggleLPA === false) {
        this.rootStore.TOGGLE_SWITCH_LPA(true);
      } else {
        this.rootStore.TOGGLE_SWITCH_LPA(false);
      }
    },
    // toggleMOswitch: function () {
    //   this.rootStore.SET_PRIMARY_CARD", []);

    //   if (this.getToggleMO === false) {
    //     this.rootStore.TOGGLE_SWITCH_MO", true);
    //   } else {
    //     this.rootStore.TOGGLE_SWITCH_MO", false);
    //   }
    // },
    toggleLTswitch: function () {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.SET_PRIMARY_CARD([]);

      if (this.rootStore.toggleLT === false) {
        this.rootStore.TOGGLE_SWITCH_LT(true);
      } else {
        this.rootStore.TOGGLE_SWITCH_LT(false);
      }
    },
    toggleIRPswitch: function () {
      this.rootStore.clearClosedOfficeMode();
      this.rootStore.SET_PRIMARY_CARD([]);

      if (this.rootStore.toggleIRP === false) {
        this.rootStore.TOGGLE_SWITCH_IRP(true);
      } else {
        this.rootStore.TOGGLE_SWITCH_IRP(false);
      }
    },
    // toggleClosedswitch: function () {
    //   this.rootStore.SET_PRIMARY_CARD", []);

    //   if (this.getToggleClosed === false) {
    //     this.rootStore.TOGGLE_SWITCH_CLOSED", true);
    //   } else {
    //     this.rootStore.TOGGLE_SWITCH_CLOSED", false);
    //   }
    // },
  },
  computed: {
    getToggleDL() {
      return this.rootStore.toggleDL;
    }
  },
};
</script>